import { isNewStatus as isNewStatusSelector } from 'app/App/selectors/editStatus';
import { notifySuccess } from 'app/Notifications/actions';
import { removeActivePage } from 'app/Page/actions';
import { visitFolder } from 'app/Router/actions';
import connect from 'utils/store/connect';

import DiscardButton from './components/DiscardButton';

/**
 * maps redux state to component props
 * @param {object} state - the current state
 * @returns {object} properties of state to be mapped to this component's props
 */
const mapStateToProps = state => ({
  isNewStatus: isNewStatusSelector(state)
});

const mapDispatchToProps = {
  notifySuccess,
  removeActivePage,
  visitFolder
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscardButton);
